import HttpException from './HttpException';

export default class AccessDeniedHttpException extends HttpException {
    name = 'AccessDeniedHttpException';

    shouldBeReported = false;

    constructor(response: Response, message?: string) {
        super(response, message ?? 'Exceptions.services.http.access_denied');
    }
}
